import React, { useCallback, useRef, useState, useEffect } from 'react';
import { Radio, Select, Typography, Space, Button, Tooltip , Checkbox, Popover, TimePicker, Row, Col, Alert} from 'antd';
import moment from "moment";
import { SNOOZE_OPTIONS } from 'constants/NotificationConstants';
import { SecurityToolsData } from 'views/Integrations/new/util';
import ModalUtil from 'utils/modalUtil';
import WarningPopup from 'components/WarningPopup';
import ToolScanSchedulerAPI from 'restAPI/ToolScanSchedulerAPI';
import message from "components/CustomMessage";
import AuthorisedContainer from 'components/AuthorisedContainer';
import { PermissionSetMap } from 'constants/RBACConstants';
import ProductSubproductLevelSettings from "./ProductSubproductLevelSettings";
import MarkInactiveAfter, { validateInactiveDuration } from './MarkInactiveAfter';
import ToolSettingsStatusMapping from './ToolSettingsStatusMapping';
import ToolSettingsSeverityMapping from './ToolSettingsSeverityMapping';
import ToolProjectVersionPhase from './ToolProjectVersionPhase';
import ToolConfidenceLevel from './ToolConfidenceLevel'
import ToolStorageSupport from './ToolStorageSupport';
import ToolRiskSupport from './ToolRiskSupport';
import ToolsIntegrationsAPI, { ToolSeverityMappingAPI, ToolStatusMappingAPI, ToolProjectPhasesMappingAPI, ToolExcludeScanReportAPI, ToolArchiveStateAPI, ToolStorageSupportAPI, CoverityIssueKindAPI, WhiteHatRiskSupportAPI, ToolFindingStatusMappingSupportAPI, ToolConfigurationNotesOptInUsersAPI, GithubSecretScanSupportAPI, CheckmarxOneScanFiltersAPI, JfrogXraySeverityFilterAPI, EndorLabsBranchTypeFilterAPI, GSCCConfigAPI } from 'restAPI/ToolsIntegrationAPI';
import { toolNameForAPI } from 'views/Integrations/GenericPullAndPushToolView';
import { useGlobalFilterContext } from 'contexts/GlobalFilterContext';
import _, { isEmpty, isNull, isUndefined } from 'lodash';
import Vocabulary from 'components/Vocabulary';
import { TOOL_STATUS_MAPPING_SUPPORT, TOOL_STATUS, PROJECT_VERSION_PHASES_SUPPORT, API_PHASE_TOOL_NAME, EXCLUDE_SCAN_REPORT_SUPPORTED_TOOL, EXCLUDE_WORK_FLOW_TOOL_NAME, ARCHIVED_SUPPORTED_TOOL, STORAGE_USAGE_SUPPORT_TOOL, STORAGE_SUPPORT_TOOL_NAME, FINDING_STATUS_MAPPING_SUPPORT, CONFIDENCE_FINDINGS_SUPPORT, RISK_REPORT_SUPPORT_TOOL_NAME, SEVERITY_FILTER_SUPPORT_TOOL } from './SettingStatusConstant'
import { useFeatureFlag } from 'contexts/FeatureFlagContext';
import { HelpIcon, InfoIcon } from 'components/Icons';
import ExcludeScanReport from './ExcludeScanReport';
import CoverityIssueKindSelection from './CoverityIssueKindSelection';
import WhiteHatRiskSupportSelection from './WhiteHatRiskSupportSelection';
import ToolConfigNotesOptInUsersListSelection from "./ToolConfigNotesOptInUsersListSelection";
import GithubSecretScanExperimentalFindingIngestionSelection from './GithubSecretScanExperimentalFindingIngestionSelection';
import CheckmarxOneScanFilters from './CheckmarxOneScanFilters';
import JfrogXraySeverityFilter from './JfrogXraySeverityFilter';
import TrackTrivyLatestVersionFindingsCheckbox from 'views/Integrations/Trivy/TrackLatestVersionFindingsCheckbox';
import GlobalSettingAPI from 'restAPI/GlobalSettingAPI';
import GithubSecretScanHideSecretLiteralsSelection from 'views/Integrations/githubSecretScan/GithubSecretScanHideSecretLiteralsSelection';
import GithubSecretScanRealtimeIngestionSelection from './GithubSecretScanRealtimeIngestionSelection';
import EndorLabsBranchTypeFilter from './EndorLabsBranchTypeFilter';
import { toolsName } from 'views/GlobalSettings/ToolsName';
import useAPIResponse from 'hooks/useAPIResponse';
import { parseSelectOptions } from 'utils/formUtils';
import SCCSkipIngestedFindingInMutedStateCheckbox from 'views/Integrations/googleSecurityCommandCenter/SCCSkipIngestedFindingInMutedStateCheckbox';
import ToolFindingStatusSeverityPreference from './ToolFindingStatusSeverityPreference';

const FREQUENCY_RESTRICTED_CATEGORIES = ["Container Security", "Infrastructure Tools", "CSPM"];
const SCAN_FREQUENCY_LIMIT_BYPASS_TOOLS = ["Checkmarx One"];

const ToolSettingsListing = ({name, hidePullView, pullLoginDetails, ...props}) => {
    const [toolLevel, setToolLevel] = useState(true);
    const [bidirectionalEnabled, setBidirectionalEnabled] = useState();
    const [archiveStateEnabled, setArchiveStateEnabled] = useState();
    const [findingStatusMappingEnabled, setFindingStatusMappingEnabled] = useState();
    const [statusSeverityPreference, setStatusSeverityPreference] = useState({ updatePreference: 'ARMORCODE', reopenSource: false });
    const toolName = toolNameForAPI(name);
    const [toolLevelData, setToolLevelData] = useState(undefined);
    const [toolFrequencyInterval, setToolFrequencyInterval] = useState(undefined);
    const [startTime, setStartTime] = useState(undefined)
    const [markInactiveAfter, setMarkInactiveAfter] = useState(undefined);
    const [frequencyUnit, setFrequencyUnit] = useState(undefined);
    const [severityMappingData, setSeverityMappingData] = useState({tool: toolName});
    const [statusMappingData, setStatusMappingData] = useState({})
    const [phaseMappingData, setPhaseMappingData] = useState()
    const [toolConfidenceLevelData, setToolConfidenceLevelData] = useState()
    const [storageSupportData, setStorageSupportData] = useState();
    const [riskReportData, setRiskReportData] = useState();
    const [excludeScanReportData, setExcludeScanReportData] = useState()
    const [validationError, setValidationError] = useState(false);
    const [rapid7InsightCSCompliancePacks, setRapid7InsightCSCompliancePacks] = useState();
    const { isError, errorMessage } = validateInactiveDuration({ toolFrequencyInterval, markInactiveAfter, frequencyUnit });
    const { globalFilterHash } = useGlobalFilterContext();
    const featureFlags = useFeatureFlag();
    /** bidirectionalStatusSupport flag is for tools who support armorcode to status update*/
    const { isBidirectionalTool, bidirectionalStatusSupport, ToolSettingsComponent, bidrectionalFeatureKey, invertFlag } = props;
    const dependabotSyncPrRef = useRef();
    const issueKindRef = useRef();
    const riskSupportMethod = useRef();
    const toolConfigOptInUsersListRef = useRef();
    const expFindingIngestion = useRef();
    const hideSecretLiteralsRef=useRef();
    const realtimeIngestionRef=useRef();
    const scanFiltersRef = useRef();
    const trivyDedupeCheckboxHandleRef = useRef();
    const sccSkipIngestedFindingInMutedStateCheckboxRef = useRef();
    const jfrogXraySeverityFilterRef = useRef(); 
    const endorLabsBranchTypeFilterRef = useRef();
    const [selectedPacks] = useAPIResponse(() => GlobalSettingAPI.getRapid7InsightCSPacks(), []);
    
    const onChange = (e) => {
        const value = e.target.value;
        value === 1 ? setToolLevel(true) : setToolLevel(false);
    }
    const handleStatusAndSeverityChange = useCallback((event)=> {
        setBidirectionalEnabled(event.target.checked)
    },[])

    const handleArchiveStateChange = useCallback((event)=> {
        setArchiveStateEnabled(event.target.checked)
    },[]);

    const handleFindingStatusMappingSupportChange = useCallback((event)=> {
        setFindingStatusMappingEnabled(event.target.checked)
    },[]);
    
    
    const handleToolSeverityChange = useCallback((values) => {
        setSeverityMappingData(severityMappingData => ({ ...severityMappingData, ...values}))
    }, [])

    const handleToolStatusChange = useCallback((values) => {
        setStatusMappingData(statusMappingData => ({ ...statusMappingData, ...values}))
    }, [])

    
    const handleToolPhaseChange = useCallback((values) => {
        setPhaseMappingData(values)
    }, []);

    const handleToolConfidenceLevelChange = useCallback((values) => {
        setToolConfidenceLevelData(values)
    }, []);

    const handleStorageSupportChange = useCallback((values) => {
        setStorageSupportData(values)
    }, []);

    const handleRiskReportChange = useCallback((values) => {
        setValidationError(!values.length)
        setRiskReportData(values)
    }, []);

    const handleValidationError = useCallback((value) => {
        setValidationError(value)
    }, []);

    const handleExcludeScanReport = useCallback(values => {
        setExcludeScanReportData(values)
    },[])

    const handleChangeMarkInactiveAfter = useCallback(({ target: { value } }) => {
        setMarkInactiveAfter(value);
    },[]);

    useEffect(() => {
        if (!isNull(selectedPacks)) {
            setRapid7InsightCSCompliancePacks(selectedPacks);
        }
    }, [selectedPacks])

    const handleRapid7InsightCSPackChange = useCallback((values) => {
        setRapid7InsightCSCompliancePacks(values);
    },[]);

    const getFrequencyOptions = useCallback(() => {
        const toolData = SecurityToolsData.find(tool => tool.name === toolName);
        
        let filteredOptions = SNOOZE_OPTIONS;
        if (featureFlags.SCAN_FREQUENCY_LIMITS && !SCAN_FREQUENCY_LIMIT_BYPASS_TOOLS.includes(toolName)) {
            if (toolData && toolData.category) {
                let categories = Array.isArray(toolData.category) ? toolData.category : [toolData.category];

                if(toolData.categoryFeatureFlag){
                    _.forEach(toolData.categoryFeatureFlag, (category, featureFlagKey)=> {
                    const featureFlagArr = featureFlagKey.split(",");
                    const allFeatureFlagMatch = _.every(featureFlagArr, (featureFlag) => featureFlags[featureFlag.trim()])
                    if(allFeatureFlagMatch){
                        categories = [...categories, ...category]
                    }
                    });
                }
                
                if (FREQUENCY_RESTRICTED_CATEGORIES.some(cat => categories.includes(cat))) {
                    filteredOptions = SNOOZE_OPTIONS.filter(option => 
                        !["15 Minutes", "30 Minutes", "1 Hour"].includes(option.label)
                    );
                }
            }
        }
        
        return filteredOptions;
    }, [featureFlags, toolName]);

    const frequencyOptions = getFrequencyOptions();

    const parseToolLevelData = useCallback((data) => {
        setToolLevelData(data);
        if(!data){
            return;
        }
        const { interval, markInactiveAfter: inActiveAfter, frequencyUnit: frequencyUnitFromApi, startTime } = data;
        setToolFrequencyInterval(interval);

        const _startTime = startTime ? moment.utc(startTime, "h:mm a").local() : startTime;
        setStartTime(_startTime)
        
        setMarkInactiveAfter(inActiveAfter);
        setFrequencyUnit(frequencyUnitFromApi);
    },[]);

    const fetchToolScanFreqency = useCallback(async () => {
        setToolLevelData(undefined);
        try{
            const data = await ToolScanSchedulerAPI.getToolScanFrequency(toolName).promise;
            parseToolLevelData(data);
        } catch (err) {
            console.log(err);
            parseToolLevelData(null);
        }
    }, [toolName,parseToolLevelData])

    const getToolStatusAndSeverityUpdateStatus = useCallback(() => {
        const { promise, cancel } = ToolStatusMappingAPI.getToolStatusAndSeverityUpdateStatus(toolName);
        promise.then(res=> {
            _.isEmpty(res) ? setBidirectionalEnabled(true) : setBidirectionalEnabled(res.bidirectionalEnabled)
            if (res?.statusSeverityUpdatePreference) {
                try {
                    const pref = JSON.parse(res.statusSeverityUpdatePreference);
                    setStatusSeverityPreference({
                        updatePreference: pref.updatePreference,
                        reopenSource: !(_.isUndefined(pref.reopenSource) || pref.reopenSource === 'LATEST')
                    });
                } catch (e) {
                    console.error('Failed to parse statusSeverityUpdatePreference', e);
                }
            }
        });
        return cancel;
    },[toolName])

    const getToolArchiveStatus = useCallback(() => {
        const { promise, cancel } = ToolArchiveStateAPI.getToolArchiveStatus({toolName});
        promise.then(setArchiveStateEnabled);
        return cancel;
    },[toolName])

    const getToolFindingStatusMappingSupportStatus = useCallback(() => {
        const { promise, cancel } = ToolFindingStatusMappingSupportAPI.getToolMappingStatus(_.toLower(toolName));
        promise.then((res) => setFindingStatusMappingEnabled(res.statusMappingToggle));
        return cancel;
    },[toolName])

    useEffect(() => {
        return getToolStatusAndSeverityUpdateStatus();
    }, [globalFilterHash, getToolStatusAndSeverityUpdateStatus])

    useEffect(() => {
        if(featureFlags.ARCHIVE_DELETED_PROJECTS && ARCHIVED_SUPPORTED_TOOL.includes(toolName)){
            return getToolArchiveStatus();
        }
    },[globalFilterHash, featureFlags, toolName, getToolArchiveStatus])

    useEffect(() => {
        if(FINDING_STATUS_MAPPING_SUPPORT.includes(toolName)){
            return getToolFindingStatusMappingSupportStatus();
        }
    },[globalFilterHash, toolName, getToolFindingStatusMappingSupportStatus])

    useEffect(() => {
        fetchToolScanFreqency();
    }, [globalFilterHash, fetchToolScanFreqency]);

    const saveToolSettings = useCallback(async () => {
        try{
            const requestPayload = {
                toolName, 
                interval: toolFrequencyInterval,
                markInactiveAfter,
                frequencyUnit,
            }

            requestPayload.startTime = startTime ? startTime.utc().format('h:mm a') : startTime;
            
            let severityMappedData= { ...severityMappingData };
            const statusMapData = statusMappingData.statusMapping || {};
            const checkEmpty = (status) => _.isEmpty(status) ? [] : status;

            let toolId = undefined;
            let toolSettingsApi = ToolScanSchedulerAPI.postToolScanFrequency;
            if(toolLevelData && toolLevelData.id){
                toolId = toolLevelData.id;
                toolSettingsApi = ToolScanSchedulerAPI.updateToolScanFrequency;
            }

            const promiseArray = [];

            promiseArray.push(toolSettingsApi(requestPayload,toolId).promise)

            if(severityMappedData?.mapping && _.isUndefined(severityMappedData?.id)){
                const resData = await ToolSeverityMappingAPI.getToolSeverityMapping().promise;
                const res = resData?.find(item => item.tool === toolName)
                if(!_.isUndefined(res)){
                    severityMappedData = {...res,...severityMappingData};
                }
            }
            const paramsObj = {}
            const keysToExtract = ["tool", "mapping"];
            for (const key of keysToExtract) {
                if (severityMappedData.hasOwnProperty(key)) {
                    paramsObj[key] = severityMappedData[key];
                }
            }

            if(severityMappedData.mapping) {
                promiseArray.push(ToolSeverityMappingAPI[`${severityMappedData.id ? "updateToolSeverityMapping" : "createToolSeverityMapping"}`](paramsObj, severityMappedData.id).promise)
            }

            const statusData = {
                configType : "TOOL_CONFIG",
                config: {
                    ...(!_.isEmpty(statusMapData) && { status: TOOL_STATUS.reduce((acc, status) => {
                        acc[status] = checkEmpty(statusMapData[status]);
                        return acc
                        }, {}) }),
                    ...(!_.isEmpty(riskReportData) && { riskReportType: riskReportData })
                }
            };
            
            if(!_.isEmpty(statusMappingData.statusMapping) || !_.isEmpty(riskReportData)){
                promiseArray.push(ToolStatusMappingAPI["createToolStatusMapping"](statusData, toolNameForAPI(toolName, name)).promise)
            }

            if(!_.isUndefined(phaseMappingData)){
                promiseArray.push(ToolProjectPhasesMappingAPI.updateToolProjectPhaseMapping(API_PHASE_TOOL_NAME[toolName], phaseMappingData).promise);
            }

            if(!_.isUndefined(storageSupportData)){
                promiseArray.push(ToolStorageSupportAPI.updateToolStorageSupportMapping(STORAGE_SUPPORT_TOOL_NAME[toolName], storageSupportData).promise);
            }
            
            if(!_.isUndefined(excludeScanReportData)){
                promiseArray.push(ToolExcludeScanReportAPI.updateExcludedWorkFlows(EXCLUDE_WORK_FLOW_TOOL_NAME[toolName], excludeScanReportData).promise);
            }

            const preferenceData = {
                updatePreference: statusSeverityPreference.updatePreference,
                reopenSource: statusSeverityPreference.reopenSource ? 'ARMORCODE' : 'LATEST'
            };
            const toolSettingsPayload = {
                bidirectionalEnabled: isBidirectionalTool ? bidirectionalEnabled : false,
                statusSeverityUpdatePreference: JSON.stringify(preferenceData)
            };
            promiseArray.push(ToolStatusMappingAPI.postToolStatusAndSeverityUpdateStatus(toolName, toolSettingsPayload).promise)

            if(_.isBoolean(archiveStateEnabled)){
                promiseArray.push(ToolArchiveStateAPI.postToolArchiveStatus(toolName, archiveStateEnabled).promise)
            }
            if(!_.isUndefined(issueKindRef.current)){
                const issueKindData=issueKindRef.current?.getFieldValue("issueKind");
                if(issueKindData){
                    promiseArray.push(CoverityIssueKindAPI.updateIssueKind(issueKindData).promise)
                }
            }
            if(!_.isUndefined(scanFiltersRef.current)){
                const branches = scanFiltersRef.current?.getFieldValue("branches");
                const initiators = scanFiltersRef.current?.getFieldValue("initiators");
                const filtersData = {
                    "branches": (branches === null || branches === undefined) ? "" : String(branches),
                    "initiators": (initiators === null || initiators === undefined) ? "" : String(initiators),
                };
                promiseArray.push(CheckmarxOneScanFiltersAPI.updateScanFilters({ config: filtersData }).promise)
            }
            if(!_.isUndefined(jfrogXraySeverityFilterRef.current)){
                const severities = jfrogXraySeverityFilterRef.current?.getFieldValue("severities"); 
                if(severities && severities.length > 0){
                    const severityData = {
                        config: {
                            severities: severities
                        }
                    };
                    promiseArray.push(JfrogXraySeverityFilterAPI.updateSeverityFilters(severityData).promise); 
                }
            }    
            if (!_.isUndefined(endorLabsBranchTypeFilterRef.current)) {
                const branchType = endorLabsBranchTypeFilterRef.current?.getFieldValue("branchType");
                if (branchType) {
                    const branchTypeData = {
                        config: {
                            branchType: branchType
                        }
                    };
                    promiseArray.push(EndorLabsBranchTypeFilterAPI.updateBranchTypeFilter(branchTypeData).promise);
                }
            }    
            if(!_.isUndefined(toolConfigOptInUsersListRef.current)){
                const selectedUsersListData=toolConfigOptInUsersListRef.current?.getFieldValue("optInUsersList");
                const allToolSelectedUsersListData=toolConfigOptInUsersListRef.current?.getFieldValue("allToolOptInUsers");  
                let toolSelectedUserListData = allToolSelectedUsersListData[toolName] || [];

                const currentTime = new Date().toISOString();
                toolSelectedUserListData = toolSelectedUserListData.filter(obj => selectedUsersListData.includes(obj.id));
                selectedUsersListData.forEach(id => {
                    if (!toolSelectedUserListData.some(obj => obj.id === id)) {
                        toolSelectedUserListData.push({ id: id, optInTime: currentTime });
                    }
                });

                allToolSelectedUsersListData[toolName] = toolSelectedUserListData;
                
                if(selectedUsersListData){
                    promiseArray.push(ToolConfigurationNotesOptInUsersAPI.saveToolConfigurationNotesOptInUsers(allToolSelectedUsersListData).promise)
                }
            }
            if(!_.isUndefined(riskSupportMethod.current)){
                const method=riskSupportMethod.current?.getFieldValue("method");
                if(method){
                    promiseArray.push(WhiteHatRiskSupportAPI.updateRiskSupportMethod({ config:{method} }).promise)
                }
            }
            if(!isUndefined(rapid7InsightCSCompliancePacks)){
                promiseArray.push(GlobalSettingAPI.updateRapid7InsightCSPacks(rapid7InsightCSCompliancePacks).promise);
            }
            const updates = {};
            let needsUpdate = false;
            if (!_.isUndefined(expFindingIngestion.current)) {
              const expFindingIngestionToggleCheck = expFindingIngestion.current?.getFieldValue("expFindingIngestionToggle");
              if (expFindingIngestionToggleCheck) {
                updates.expFindingIngestionToggle = !_.isUndefined(expFindingIngestionToggleCheck[0]) ? expFindingIngestionToggleCheck[0] : false;
                needsUpdate = true;
              }
            }

            if (!_.isUndefined(hideSecretLiteralsRef.current)) {
              const toggleCheck = hideSecretLiteralsRef.current?.getFieldValue("hideSecretLiteralsToggle");
              if (!_.isUndefined(toggleCheck)) {
                updates.hideSecretLiteralsToggle = toggleCheck;
                needsUpdate = true;
              }
            }

            if (!_.isNil(realtimeIngestionRef.current)) {
              const toggleCheck = realtimeIngestionRef.current.getFieldValue("realtimeIngestionToggle");
              if (!_.isNil(toggleCheck)) {
                updates.realtimeIngestionToggle = toggleCheck;
                needsUpdate = true;
              }
            }

            // Chain fetch→update as a single promise so Promise.all awaits it before showing success
            if (needsUpdate) {
              promiseArray.push(
                GithubSecretScanSupportAPI.getGithubSecretScanToolConfig().promise.then((resData) => {
                  const existingConfig = resData?.config || {};
                  const updatedConfig = {
                    ...existingConfig,
                    ...updates
                  };
                  return GithubSecretScanSupportAPI.updateGithubSecretScanToolConfig({
                    config: updatedConfig,
                  }).promise;
                })
              );
            }
            if(_.isBoolean(findingStatusMappingEnabled)){
                promiseArray.push(ToolFindingStatusMappingSupportAPI.postToolMappingStatus(_.toLower(toolName), { statusMappingToggle: findingStatusMappingEnabled }).promise)
            }


            const confidenceLevelData = {
                configType : "TOOL_CONFIG_CONTRAST_SECURITY",
                config: {
                    confidenceLevel: toolConfidenceLevelData
                }
            };

            if(!_.isUndefined(toolConfidenceLevelData)){
                promiseArray.push(ToolStatusMappingAPI["createToolStatusMapping"](confidenceLevelData, toolNameForAPI(toolName, true)).promise);
            }

            if(!_.isNil(trivyDedupeCheckboxHandleRef.current?.getValue())){
                const trivyDedupeCheckboxValue = trivyDedupeCheckboxHandleRef.current.getValue();
                promiseArray.push (GlobalSettingAPI.updateTenantConfig(
                "TRIVY_DEDUP_WITHOUT_IMAGE_ID",
                trivyDedupeCheckboxValue,
              ).promise)
            }

            if(!_.isNil(sccSkipIngestedFindingInMutedStateCheckboxRef.current?.getValue())){
                const skipMutedFindings = sccSkipIngestedFindingInMutedStateCheckboxRef.current.getValue();
                promiseArray.push(GSCCConfigAPI.updateConfig({ skipMutedFindings }).promise);
            }

            Promise.all(promiseArray)
                .then(() => {
                    if(dependabotSyncPrRef.current && dependabotSyncPrRef.current.onSave){
                        dependabotSyncPrRef.current.onSave();
                    }
        
                    message.success("Tool level settings updated succesfully!");
                    fetchToolScanFreqency();
            })
        }catch(err){
            console.log(err);
        }
    },[ 
        toolLevelData,
        toolName,
        toolFrequencyInterval,
        startTime,markInactiveAfter,
        frequencyUnit,
        fetchToolScanFreqency, 
        severityMappingData, 
        statusMappingData,name, 
        phaseMappingData,
        bidirectionalEnabled, 
        isBidirectionalTool,
        excludeScanReportData,
        archiveStateEnabled,
        storageSupportData,
        riskReportData,
        findingStatusMappingEnabled, 
        toolConfidenceLevelData,
        rapid7InsightCSCompliancePacks,
        statusSeverityPreference,
    ]);

    const onSaveToolSettings = useCallback(() => {
        if(validationError) return;
        ModalUtil.show({
            content: <WarningPopup 
                okText={"Save"}
                promptMessage="This will change the tool level settings. Are you sure you want to change this?"
                onOk={saveToolSettings}
            />
        })
    },[saveToolSettings, validationError]);

    const bidirectionalFeatureValue = featureFlags[bidrectionalFeatureKey];

    return ( <>
        <div>
            <Typography.Text className='m-y-sm' style={{width: 616, display: 'block'}}>
                Set the configuration at tool level{!hidePullView && <> or specific to <Vocabulary name="product" /> or <Vocabulary name="subProduct" /></>}. Tool <Vocabulary name="severity" /> can be mapped to ArmorCode <Vocabulary name="severity" /> e.g in Sync it can be <Vocabulary name="critical"/>, but here <Vocabulary name="high"/>, can be configured.
            </Typography.Text>
            {
                !hidePullView && (
                    <Radio.Group className="m-m" name="toolSettings" defaultValue={1} onChange={onChange} buttonStyle="solid">
                        <Radio.Button value={1}>Tool Level</Radio.Button>
                        <Radio.Button value={2}>Specific</Radio.Button>
                    </Radio.Group>
                )
            }
        </div>
        {toolLevel ? 
                <Space className="m-m" direction="vertical">
                     {
                            (FINDING_STATUS_MAPPING_SUPPORT.indexOf(toolName) !== -1) ?
                            <div className='p-y-sm'>
                                <Checkbox checked={findingStatusMappingEnabled} onChange={handleFindingStatusMappingSupportChange} />&nbsp;
                                <Typography.Text>
                                    <>Only ingest findings of mapped {toolName} status. <Tooltip title={<>With this option enabled ArmorCode will only ingest findings of {toolName} statuses that are mapped in the ArmorCode configuration mapping.</>}><InfoIcon/></Tooltip></>
                                </Typography.Text>
                            </div>
                            :
                            null

                        }
                    {
                        // dropdown to select issue kind for coverity
                        toolName==="Coverity"
                        ?
                        <CoverityIssueKindSelection toolName={toolName}  ref={issueKindRef}/>
                        :
                        null
                    }
                    {
                        (toolName==="Checkmarx One" && featureFlags.ENABLE_CHECKMARXONE_SCAN_FILTERS)
                        ?
                        <CheckmarxOneScanFilters toolName={toolName} handleValidationError={handleValidationError} ref={scanFiltersRef} />
                        :
                        null
                    }
                    {
                        SEVERITY_FILTER_SUPPORT_TOOL.indexOf(toolName) !== -1 
                        ?
                        <JfrogXraySeverityFilter toolName={toolName} ref={jfrogXraySeverityFilterRef} /> 
                        :
                        null
                    }
                    {
                        toolName === "Endor Labs"
                        ? <EndorLabsBranchTypeFilter toolName={toolName} ref={endorLabsBranchTypeFilterRef} />
                        : null
                    }
                    {
                        CONFIDENCE_FINDINGS_SUPPORT.indexOf(toolName) !== -1
                        ?
                        <ToolConfidenceLevel
                            toolName={ toolNameForAPI(toolName, true) }
                            handleToolConfidenceLevelChange={handleToolConfidenceLevelChange}
                        />
                        :
                        null
                    }
                    {
                         // radio button to select risk support method for whitehat sentinel
                         toolName==="WhiteHat Sentinel"
                         ?
                         <WhiteHatRiskSupportSelection toolName={toolName}  ref={riskSupportMethod}/>
                         :
                         null
                    }
                    {
                         // toggle button to select experimental findings ingestion for github secret scan
                         toolName==="Github Secret Scan"
                         ?
                         <GithubSecretScanExperimentalFindingIngestionSelection toolName={toolName} ref={expFindingIngestion}/>
                         :
                         null
                    }
                    {
                         toolName==="Github Secret Scan"
                         ?
                         <GithubSecretScanHideSecretLiteralsSelection toolName={toolName} ref={hideSecretLiteralsRef}/>:null
                    }
                    {
                         toolName==="Github Secret Scan" && featureFlags.GITHUB_SECRET_SCAN_REALTIME_INGESTION
                         ?
                         <GithubSecretScanRealtimeIngestionSelection toolName={toolName} ref={realtimeIngestionRef}/>:null
                    }
                    {
                        // we need to keep status mapping seprate with Bidirectional
                        TOOL_STATUS_MAPPING_SUPPORT.indexOf(toolName) !== -1 && (featureFlags[props.showStatusMappingKey] || !props.showStatusMappingKey)
                        ?
                        <ToolSettingsStatusMapping 
                            toolName={ toolName }
                            handleToolStatusChange={handleToolStatusChange}
                        />
                        :
                        null
                    }
                    {
                        featureFlags.VERSIONS && PROJECT_VERSION_PHASES_SUPPORT.indexOf(toolName) !== -1
                        ?
                        <ToolProjectVersionPhase
                            toolName={ toolName }
                            handleToolPhaseChange={handleToolPhaseChange}
                        />
                        :
                        null
                    }
                     {
                        STORAGE_USAGE_SUPPORT_TOOL.indexOf(toolName) !== -1
                        ?
                        <ToolStorageSupport
                            toolName={ toolName }
                            handleStorageSupportChange={handleStorageSupportChange}
                        />
                        :
                        null
                    }
                    {
                        RISK_REPORT_SUPPORT_TOOL_NAME.indexOf(toolName) !== -1
                        ?
                        <ToolRiskSupport
                            toolName={ toolName }
                            handleRiskReportChange={handleRiskReportChange}
                        />
                        :
                        null
                    }
                    {
                        toolName === "Trivy" ? <TrackTrivyLatestVersionFindingsCheckbox ref={trivyDedupeCheckboxHandleRef}/> : null
                    }
                        <ToolSettingsSeverityMapping
                            toolName={toolName}
                            handleToolSeverityChange={handleToolSeverityChange}
                        />

                    <ToolFindingStatusSeverityPreference
                        updatePreference={statusSeverityPreference.updatePreference}
                        reopenSource={statusSeverityPreference.reopenSource}
                        onPreferenceChange={setStatusSeverityPreference}
                    />

                    {!hidePullView && <ToolConfigNotesOptInUsersListSelection toolName={toolName}  ref={toolConfigOptInUsersListRef}/>}
                    {
                        (isBidirectionalTool && ( _.isUndefined(bidirectionalFeatureValue) ? true : ( invertFlag ? !bidirectionalFeatureValue : bidirectionalFeatureValue))) ? (
                            <div className='p-y-sm'>
                                <Checkbox checked={bidirectionalEnabled} onChange={handleStatusAndSeverityChange} />
                                <Typography.Text className='m-l-xs'>
                                    Enable Bi-Directional status{bidirectionalStatusSupport ? <>/<Vocabulary name="severity" isLowerCase={true}/> </>: '' } Update (Recommended) &nbsp;
                                    <Popover content={<>If enabled, when the status{bidirectionalStatusSupport ? <>/<Vocabulary name="severity" isLowerCase={true}/> </>: '' } of a finding changes on ArmorCode, it will also update the finding status{bidirectionalStatusSupport ? <>/<Vocabulary name="severity" isLowerCase={true}/> </>: '' } on the Security Tool.</>} placement="top" ><HelpIcon /></Popover>
                                </Typography.Text>
                            </div>
                        ) : null
                    }
                        {
                            EXCLUDE_SCAN_REPORT_SUPPORTED_TOOL.indexOf(toolName) !== -1
                            ?
                            <ExcludeScanReport
                                toolName={ toolName }
                                handleExcludeScanReport={handleExcludeScanReport}
                            />
                            :
                            null
                        }

                    {
                        (ToolSettingsComponent) ? <ToolSettingsComponent ref={dependabotSyncPrRef} toolName={props.integrationData.name} /> : null
                    }
                    {toolName === toolsName.RAPID7_INSIGHT_CLOUD_SECURITY ? <CompliancePackFieldForRapid7InsightCloudSecurity handleChange={handleRapid7InsightCSPackChange} pullLoginDetails={pullLoginDetails} value={rapid7InsightCSCompliancePacks}/> : null}
                    {
                        !hidePullView && (
                            <Row style={{
                                position: 'relative',
                                maxWidth: 631,
                                border: '1px solid #d9d9d9',
                                padding: 19
                            }}>
                                <Typography.Text style={{
                                    position: 'absolute',
                                    top: -11,
                                    background: '#fff',
                                }}>Scan Ingestion Schedule</Typography.Text>
                                <Col span={10}>
                                    <Typography.Text>Frequency for checking scans</Typography.Text> <br />
                                    <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                    <Select
                                        placeholder="Frequency for checking scans" 
                                        style={{width: 200}} 
                                        options={frequencyOptions} 
                                        onChange={setToolFrequencyInterval} 
                                        loading={toolLevelData === undefined} 
                                        valueTTT={toolLevelData?.interval} 
                                        value={toolFrequencyInterval}
                                    />
                                    </AuthorisedContainer>
                                </Col>
                               
                                <Col span={12}>
                                    <Typography.Text>Start Time</Typography.Text><br />
                                    <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                                        <TimePicker value={startTime} use12Hours showNow={false} format="h:mm a" onChange={setStartTime}/>
                                        <span className='m-l-xs'>(GMT {moment().format('Z')})</span>
                                    </AuthorisedContainer>
                                </Col>
    
                            </Row>
                        )
                    }
                    <MarkInactiveAfter 
                        toolFrequencyInterval={toolFrequencyInterval}
                        markInactiveAfter={markInactiveAfter} 
                        frequencyUnit={frequencyUnit}
                        handleChangeMarkInactiveAfter={handleChangeMarkInactiveAfter}
                        setFrequencyUnit={setFrequencyUnit}  
                        isError={isError}
                        errorMessage={errorMessage}
                    />
                    {toolName === toolsName.GOOGLE_SECURITY_COMMAND_CENTER ? <>
                        <Typography.Text>Ingestion Settings</Typography.Text>
                        <SCCSkipIngestedFindingInMutedStateCheckbox ref={sccSkipIngestedFindingInMutedStateCheckboxRef}/>
                    </> : null}
                    <Space className="m-t-sm" direction="vertical">
                        <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                            <Button disabled={isError} onClick={onSaveToolSettings} type='primary'>Save</Button>
                        </AuthorisedContainer>
                    </Space>
                </Space>
            :
            <ProductSubproductLevelSettings toolName={toolName} />
        }
    </>
    )
}
export default ToolSettingsListing;


const CompliancePackFieldForRapid7InsightCloudSecurity = ({ handleChange, pullLoginDetails, value }) => {
    const [loading, setLoading] = useState(false);
    const [packOtions, setPackOptions] = useState([]);
    const { globalFilterHash } = useGlobalFilterContext();

    useEffect(() => {
        if (isEmpty(pullLoginDetails)) {
            setPackOptions([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        const {promise, cancel} =  ToolsIntegrationsAPI.getGenericProjectByToolName(toolsName.RAPID7_INSIGHT_CLOUD_SECURITY, {
            type: "packs",
            login_id: pullLoginDetails[0].id
        });
        promise.then(({ projects }) => setPackOptions(projects)).finally(() => setLoading(false));
        return cancel;
    }, [pullLoginDetails, globalFilterHash]);

    return (
        <Space direction="vertical" className="m-b-m">
            <Typography.Text>Select Compliance Packs to ingest associated Insights</Typography.Text>
            <Alert description={
                <AuthorisedContainer permission={PermissionSetMap.UPDATE_SLA}>
                <Select
                    placeholder="Leave blank to select all" 
                    mode="multiple"
                    style={{width: 200}} 
                    options={parseSelectOptions(packOtions)} 
                    onChange={handleChange} 
                    loading={loading} 
                    value={value}
                />
                </AuthorisedContainer>
                }
            />
        </Space>
    )                 
}
